module.exports = __webpack_public_path__ + "media/images/aspirant-1b28ac307bab4c8868b89655bac8ce50.svg";